import script from "./AuthView.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthView.vue?vue&type=script&setup=true&lang=js"

import "./AuthView.vue?vue&type=style&index=0&id=7878ddec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7878ddec"]])

export default __exports__